<template>
  <div>
    <!--Filters-->
    <b-card no-body>
      <b-card-header class="pb-50">
        <b-row no-gutters class="w-100">
          <b-col>
            <h5>{{ msg("Filters") }}</h5>
          </b-col>
          <b-col>
            <div class="d-flex justify-content-end">
              <b-link style="color: inherit" @click="refresh()">
                <feather-icon icon="RefreshCcwIcon" size="16"/>
              </b-link>
            </div>
          </b-col>
        </b-row>
      </b-card-header>
      <b-card-body>
        <b-row>
          <b-col md="3" class="">
            <b-form-group :label="msg('checkinrange')" label-for="realEstate-branch">
              <calendar-picker-range v-model="filter.checkInDate"/>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="12" lg="3">
            <b-form-group :label="$t('Real estate')" label-for="realEstate-branch">
              <real-estate-picker small v-model="filter.realEstatesId" multiple/>
            </b-form-group>
          </b-col>
          <b-col cols="12" md="4" class="mb-md-0 mb-2">
            <b-form-group :label="msg('Status')" label-for="realEstate-branch">
              <v-select multiple
                        :dir="isRTL ? 'rtl' : 'ltr'"
                        :clearable="true"
                        v-model="filter.statuses"
                        :options="allStatuses"
                        class="w-100"
                        label="text"
                        :reduce="(branch) => branch.value"

              />
            </b-form-group>
          </b-col>
          <b-col cols="12">
            <b-form-group>
              <b-form-checkbox v-model="filter.approved" inline>
                {{ msg('Approved') }}
              </b-form-checkbox>
              <b-form-checkbox v-model="filter.clientRequest" inline>
                {{ $t('clientRequest') }}
              </b-form-checkbox>

              <b-form-checkbox v-model="filter.contractVerified" inline>
                {{ $t('Verified') }}
              </b-form-checkbox>

              <b-form-checkbox v-model="filter.noPayments" inline>
                {{ $t('No payment attends') }}
              </b-form-checkbox>

            </b-form-group>
          </b-col>
          <!--        <b-col cols="12" md="4" class="mb-md-0 mb-2">
                    <label>{{ msg("Id") }}</label>
                    <b-form-input size="sm" v-model="filter.id" class="d-inline-block mr-1"/>
                  </b-col>-->
        </b-row>
      </b-card-body>
    </b-card>

    <!--Card Content-->
    <b-card no-body>
      <div class="card-header" style="overflow: hidden">
        <span class="card-title m-0">{{ msg('Guest features') }}</span>
        <b-col>
          <div class="d-flex justify-content-end">
            <b-link style="color: inherit" @click="refresh()">
              <feather-icon icon="RefreshCcwIcon" size="16"/>
            </b-link>
          </div>
        </b-col>
      </div>
      <!--Card Content-->
      <b-card-body>
      <div class="">
        <!-- Table Top -->
        <b-row no-gutters class="mb-1">
          <!-- Per Page -->
          <b-col cols="12" md="6" class="d-flex align-items-center justify-content-start mb-1 mb-md-0">
            <label>{{ msg('Show') }}</label>
            <v-select
                v-model="page.amount"
                @option:selected="refresh"
                :dir="isRTL ? 'rtl' : 'ltr'"
                :options="[10, 25, 50, 100,500]"
                :clearable="false"
                class="per-page-selector d-inline-block mx-50"
            />
            <label>{{ msg('entries') }}</label>
          </b-col>
          <b-col cols="12" class="d-flex justify-content-md-end justify-content-center align-items-center">
            <span class="card-title m-0">{{ msg('Guest Feature') }}</span>
          </b-col>

        </b-row>
      </div>
      <!--Table-->
      <b-table
          ref="feature-table"
          striped
          responsive
          v-bind:sort-by.sync="sort.by"
          v-bind:sort-direction="sort.direction"
          v-bind:sort-desc.sync="sort.desc"
          v-bind:items="features"
          v-bind:fields="fields"
          :busy="loading"
          @sort-changed="onSort"
      >
        <template #table-busy>
          <div class="text-center text-primary my-2">
            <b-spinner class="align-middle mx-1"></b-spinner>
            <strong>{{ msg('Loading') }}...</strong>
          </div>
        </template>
        <template #cell(requestTime)="data">
          {{ data.value | moment($t('timeFormat.dateTime.format')) }}
        </template>
        <template #cell(contractId)="data">
          <div class="text-capitalize" style="white-space: nowrap">
            <b-button variant="link" @click="openContract(data.item)"
                      class="text-decoration-none text-capitalize m-0 px-1" :title="$t('View Contract')">
              {{ data.item.clientName }}
            </b-button>
            <b-button variant="link" @click="openPayModal(data.item)" class="text-decoration-none m-0 p-0"
                      :title="$t('Pay orders in Contract')" v-if="canPay(data.item)">
              <i class="fa-solid fa-cash-register"></i>
            </b-button>
          </div>
        </template>

        <template #cell(payments)="data">
          <div class="position-relative">

            <b-badge
                :variant="data.item.payments.length > 0 ? 'primary' : 'secondary'"
                pill
                @click.stop="togglePaymentDropdown(data.item)"
                style="cursor:pointer;"
            >
              {{ data.item.payments.length }}
              {{ data.item.payments.length === 1 ? 'payment' : 'payments' }}
            </b-badge>

            <transition name="fade">
              <div
                  v-if="data.item._showPayments"
                  class="payment-dropdown"
              >
                <div
                    v-for="p in data.item.payments"
                    :key="p.id"
                    class="payment-item"
                >
                  <div class="d-flex justify-content-between align-items-center mb-1">
                    <div class="small">
                      {{ (p.paymentDate)| moment($t('timeFormat.dateTime.format')) }}
                    </div>

                    <b-badge :variant="p.paid ? 'success' : 'danger'">
                      {{ p.status }}
                    </b-badge>
                  </div>

                  <div class="">
                   Reason: {{ cleanReason(p.reason) }}
                  </div>


                  <span class="font-weight-bold small">
              Amount: {{ p.amount }} {{ p.currency }}
            </span>
                  <hr v-if="data.item.payments.length > 1"/>
                </div>
              </div>
            </transition>

          </div>
        </template>

        <template #cell(contractVerified)="data">

          <b-badge :variant="data.value ? 'success' : 'danger'">
            {{ data.value ? $t('Yes') : $t('No') }}
          </b-badge>

        </template>

        <template #cell(removeDisabled)="data">
          <div>
            <b-img :src="productsMapById[data.item.featureId]!=null?productsMapById[data.item.featureId].imageUri:''"
                   fluid style="max-width: 70px; max-height: 50px"/>
          </div>
        </template>

        <template #cell(checkInDate)="data">
          <span style="white-space: nowrap">{{ data.value | moment('DD/MM/YY', true) }}</span>
        </template>
        <template #cell(featureId)="data">
          <b-button variant="link" @click="openFeatureModal(data.item.id)" class="text-decoration-none">
            <i v-if="data.item.clientRequest" class="fa-solid fa-circle" :title="$t('clientRequest')"></i>
            {{ data.item.name }}
          </b-button>
        </template>
        <template #cell(approved)="data">
          <div>
            <i class="fa-solid fa-check" v-if="data.value"/>
          </div>
        </template>
        <template #cell(clientName)="data">
          <div class="text-capitalize">
            {{ data.value }}
          </div>
        </template>
        <template #cell(status)="data">
         <span class="badge badge-pill" :class="statusClass(data.value)">
            <i :class="statusIcon(data.value)"></i>
            {{ $t(`guestFeatureStatusEnum.${data.value}`) }}
          </span>
        </template>
      </b-table>

      <div class="text-center w-100">
        <div class="d-inline-block">
          <b-pagination
              v-model="page.currentPage"
              :total-rows="page.total"
              :per-page="page.amount"
              first-number
              last-number
              @input="refresh"
          />
        </div>
        <div class="d-inline-block px-2"><strong>{{ msg('Total') }}</strong> {{ page.total }}</div>
      </div>
      </b-card-body>
    </b-card>
    <guest-feature-requested-modal ref="guest-feature-modal" @update="refresh"/>
    <guest-feature-order-modal ref="guest-feature-order-modal" @update="refresh"/>
  </div>
</template>

<script>
import {mapActions} from "vuex";
import RealEstatePicker from "@/components/components/picker/realEstatesPicker.vue";
import GuestFeatureRequestedModal from "@/components/modals/feature/GuestFeatureRequestedModal.vue";
import GuestFeatureOrderModal from "@/components/modals/feature/GuestFeatureOrderModal.vue";
import CalendarPickerRange from "@/components/widgets/calendar/calendarPickerRange.vue";

const createGuestFeatureRequest = () => {
  return {
    featuresId: null, realEstatesId: null, minPrice: null, statuses: null,    noPayments: null,

    clientRequest: null, approved: null,    contractVerified: null,

    checkInDate: {
      start: null,
      end: null,
    }
  };
}


export default {
  name: "guestFeatureRequest",
  components: {CalendarPickerRange, GuestFeatureRequestedModal, RealEstatePicker, GuestFeatureOrderModal},
  data: () => ({
    loading: true,
    filter: {},
    sort: {by: 'requestTime', direction: 'desc', desc: true},
    features: [],
    page: {amount: 25, currentPage: 1, total: 0},
  }),
  created() {
    this.filter = createGuestFeatureRequest();
    this.refresh();
  },
  watch: {
    filter: {
      deep: true,
      handler() {
        this.refresh();
      }
    },
  },
  computed: {
    fields() {
      return [
        /*  {"id": "2", "branchId": 1, "featureId": "67688ac8fb6ef27ef0a6ade7", "contractId": "67b32d4840c63903ca622a42",
            "name": "Airport Pickup", "description": "Enjoy .",
            "price": 500.0, "amount": 1, "days": 1,
            "status": "PAID", "orderId": "67d0a7bd7b71561f8dce19f6",
            "clientNote": "This is an Airport test", "dailyPayment": false, "clientRequest": true, "approved": true, "finalPrice": 500.0, "finalAmount": 1
          },*/
        // {key: 'clientNote', label: this.$t('clientNote'), sortable: true},
        {key: 'removeDisabled', label: this.$t('image'), sortable: false, class: 'text-center'},
        {key: 'requestTime', label: this.$t('requestTime'), sortable: true, class: 'text-center'},
        {key: 'featureId', label: this.$t('feature'), sortable: true, class: 'text-center'},
        {key: 'contractId', label: this.$t('contract'), sortable: true, class: 'text-center'},
        {key: 'contractVerified', label: this.$t('verified'), sortable: true, class: 'text-center'},
        {key: 'checkInDate', label: this.$t('Check In'), sortable: true, class: 'text-center'},
        {key: 'fullAddress', label: this.$t('address'), sortable: true, class: 'text-center'},
        {key: 'finalAmount', label: this.$t('quantity'), sortable: false, class: 'text-center'},
        {key: 'finalPrice', label: this.$t('price'), sortable: false, class: 'text-center'},
        {key: 'approved', label: this.$t('approved'), sortable: false, class: 'text-center'},
        {key: 'status', label: this.$t('status'), sortable: false, class: 'text-center'},
        {key: 'payments', label: this.$t('payment'), sortable: false, class: 'text-center'},
      ]
    },
    allStatuses() {
      let statuses = this.$t(`guestFeatureStatusEnum`);
      return Object.keys(statuses).map((key) => {
        return {value: key, text: this.$t(`guestFeatureStatusEnum.${key}`)}
      });
    },
    productsMapById() {
      if (!Array.isArray(this.products)) {
        return {}
      }

      // Inline reduce to build the map
      return this.products.reduce((map, product) => {
        // you could also guard here if product.id is missing
        map[product.id] = product
        return map
      }, {})
    }
  },
  methods: {
    ...mapActions('guestFeatureRequest', ['fetchAllGuestFeatures']),
    cleanReason(reason) {
      if (!reason) return "";
      const parts = reason.split("-");
      return parts.length > 1 ? parts[1].trim() : reason;
    }
    ,
    togglePaymentDropdown(feature) {
      if (feature._showPayments === undefined) {
        this.$set(feature, "_showPayments", true);
      } else {
        feature._showPayments = !feature._showPayments;
      }
    }
    ,

    refresh() {
      let $this = this;
      this.loading = true;

      let request = {
        filter: this.filter,     // contractVerified is ignored by backend
        page: this.page.currentPage,
        amount: this.page.amount,
        sortcolumn: $this.sort.by,
        sortby: $this.sort.direction
      };

      this.fetchAllGuestFeatures(request).then(data => {

        let items = data.features;

// 1️⃣ Filter: Verified
        if (this.filter.contractVerified === true) {
          items = items.filter(f => f.contractVerified === true);
        } else if (this.filter.contractVerified === false) {
          items = items.filter(f => f.contractVerified === false);
        }

// 2️⃣ Filter: NO PAYMENTS attended
        if (this.filter.noPayments === true) {
          items = items.filter(f => !f.payments || f.payments.length === 0);
        }

        $this.features = items;


        // Update pagination using filtered count
        $this.page.total = items.length;
        $this.page.currentPage = 1; // reset if needed
        $this.page.amount = data.Amount;

      }).finally(() => {
        $this.loading = false;
      })
    }
    ,

    statusClass(status) {
      return {
        "badge-success": status === "PAID",
        "badge-warning": status === "REQUESTED",
        "badge-danger": status === "CANCELED",
      };
    },
    statusIcon(status) {
      return {
        PAID: "fas fa-check-circle",
        REQUESTED: "fas fa-hourglass-half",
        CANCELED: "fas fa-times-circle",
      }[status] || "fas fa-info-circle";
    },
    openContract(feature) {
      window.open(`/real_estate/contracts/rent/${feature.contractId}#guest-feature`, '_blank');
    },
    openPayModal(feature) {
      this.$refs['guest-feature-order-modal'].show(feature.contractId);
    },
    openFeatureModal(featureId) {
      this.$refs['guest-feature-modal'].show(featureId);
    },
    canPay(feature) {
      return feature.status === "REQUESTED" && feature.approved === true;
    },
    onSort(data) {
      this.sort.by = data.sortBy
      this.sort.direction = data.sortDesc ? 'desc' : 'asc'
      this.refresh()
    },
  },
}
</script>


<style scoped>
.payment-dropdown {
  position: absolute;
  top: 25px;
  right: 0;
  left: auto;
  background: white;
  border: 3px solid #dcdcdc;
  border-radius: 6px;
  padding: 10px;
  width: 280px;

  max-height: 200px;
  overflow-y: auto;

  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  z-index: 9999; /* IMPORTANT for b-table */
}

.dark-layout .payment-dropdown {
  top: 25px;
  right: 0;
  left: auto;
  background: #283046;
  border: 1px solid #dcdcdc;
  border-radius: 6px;
  padding: 10px;
  width: 280px;

  max-height: 200px;
  overflow-y: auto;

  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.15);
  z-index: 9999; /* IMPORTANT for b-table */
}


.payment-item {
  margin-bottom: 6px;
}

.payment-item hr {
  margin: 6px 0;
  opacity: 0.2;
}

/* smooth fade */
.fade-enter-active,
.fade-leave-active {
  transition: opacity .15s ease;
}

.fade-enter,
.fade-leave-to {
  opacity: 0;
}

</style>
